import EventBus from "../../../../util/EventBus";
import withNavigate from "../../../../util/useNavigate";
import Applet from "../../Applet";
import EnlilDetailDialog from "../../../../components/EnlilDetailDialog";

class DeveloperApplicationFormApplet extends Applet {
    state = {
        Name: "DeveloperApplicationFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "Active",
                            },
                            {
                                id: "EmployeeUSID",
                            },
                        ],
                    },
                ],
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "EmployeeUSID",
                            },
                        ],
                    },
                ],
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "EmployeeUSID",
                            },
                            {
                                id: "Active",
                            },
                        ],
                    },
                ],
            },
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            Name: {
                id: "Name",
                enterpriseComponentAttribute: "Name",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Special Characters",
                        value: null,
                        errorText: "Field must not have special characters.",
                    },
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Name",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            Active: {
                id: "Active",
                enterpriseComponentAttribute: "Active",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Active",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Switch",
                requiresConfirmation: false,
            },
            EmployeeUSID: {
                id: "EmployeeUSID",
                enterpriseComponentAttribute: "EmployeeUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                type: "Select",
                requiresConfirmation: false,
                errors: [],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Employee",
                    margin: "dense",
                },
                ip: {},
                default: {
                    type: "Computed",
                    value: "Employee USID",
                },
            },
        },
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("developer-application-form-applet-cancel");
    };

    setAction(action) {
        super.setAction(action);

        if (action === "Save Completed") {
            EventBus.components.emit("developer-application-form-applet-save");
        }
    };

    render() {
        return <EnlilDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Application"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default withNavigate(DeveloperApplicationFormApplet);
